import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
  } from "@mui/material";
  import React, { useEffect, useState } from "react";
  
  const NotificationPopup = ({ open, onClose, isOk , message}) => {
    useEffect(()=>{
      if(open){
        const timer=setTimeout(onClose, 3000);
        return ()=>clearTimeout(timer);
      }
    }, [open, onClose])
    return (
      <Dialog
        open={open}
        onClose={onClose}
        sx={{
          "& .MuiDialog-paper": { width: "90%", maxWidth: "none" },
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <DialogTitle color={isOk?"success":"error" }align="center">
          {isOk?"Success":"Error"}
        </DialogTitle>
        <DialogContent>{message}</DialogContent>
        {/* <DialogActions>
          <Button onClick={onClose} color="secondary">
            Close
          </Button>
        </DialogActions> */}
      </Dialog>
    );
  };
  export default NotificationPopup;
  